import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { OrgProvider } from './auth/OrgContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { DashboardPage } from './pages/DashboardPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { PeoplePage } from './pages/PeoplePage';
import { LibraryPage } from './pages/LibraryPage';
import { ReportingPage } from './pages/ReportingPage';
import { BillingPage } from './pages/BillingPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { ApiMcpPage } from './pages/ApiMcpPage';
import { ApiDocsPage } from './pages/ApiDocsPage';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route element={<ProtectedRoute />}>
            <Route
              element={
                <OrgProvider>
                  <Layout />
                </OrgProvider>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="campaigns" element={<CampaignsPage />} />
              <Route path="people" element={<PeoplePage />} />
              <Route path="library" element={<LibraryPage />} />
              <Route path="reporting" element={<ReportingPage />} />
              <Route path="billing" element={<BillingPage />} />
              <Route path="integrations" element={<IntegrationsPage />} />
              <Route path="api-keys" element={<ApiMcpPage />} />
              <Route path="docs" element={<ApiDocsPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
